import { render, staticRenderFns } from "./NovoAgendamento.vue?vue&type=template&id=1658870c"
import script from "./NovoAgendamento.vue?vue&type=script&lang=js"
export * from "./NovoAgendamento.vue?vue&type=script&lang=js"
import style0 from "./NovoAgendamento.vue?vue&type=style&index=0&id=1658870c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports